import React, { useMemo } from 'react';
import { Modal, Table } from 'antd';

import { groupConversionValues } from '@libs/NwFeatures';

const ConversionModal = ({ conversion, onClose }) => {
  const columns = useMemo(() => {
    let columns = [];
    if (conversion) {
      columns.push({
        title: 'Key',
        dataIndex: 'Key',
        width: '20%',
        editable: true
      });
      conversion.AvailableMetrics.split(',').map(metricKey => {
        columns.push({
          title: metricKey,
          dataIndex: metricKey,
          // width: '20%',
          editable: true,
          render: (text, record) => record.DisplayValue[metricKey] ?? ''
        });
        return null;
      });
    }
    return columns;
  }, [conversion]);

  const groupedConversionValues = useMemo(() => {
    if (!conversion) {
      return [];
    }
    // la Table vuole una rowKey minuscola: Key identifica già la riga
    return groupConversionValues(conversion.ConversionValues).map(group => ({ ...group, key: group.Key }));
  }, [conversion]);

  return (
    <Modal
      zIndex={1050}
      title={conversion.Name}
      visible={true}
      footer={null}
      onCancel={onClose}
    >
      <Table
        bordered
        dataSource={groupedConversionValues}
        columns={columns}
        rowClassName="editable-row"
        size='small'
      />
    </Modal>
  );
};

export default ConversionModal;